const STATS = [
  { label: "Active Verticals", value: "07" },
  { label: "Clients Served", value: "2" },
  { label: "Revenue Generated", value: "$3K" },
  { label: "Avg. ROI", value: "3.7x" },
];

export default function Proof() {
  return (
    <section id="proof" data-testid="proof-section" className="relative py-24 md:py-32 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div data-testid="stats-bar" className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
          {STATS.map((s) => (
            <div key={s.label} className="bg-[#05050A] p-8 md:p-10 flex flex-col items-start">
              <div className="font-mono text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight">
                {s.value}
              </div>
              <div className="overline mt-3 text-white/40">// {s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
